module.exports = __webpack_public_path__ + "img/avatar-87.260bc111.png";